import AdminDashboard from "../pages/dashboards/admin-dashboard";
import ConsultantDashboard from "../pages/dashboards/consultant-dashboard";
import ClientDashboard from "../pages/dashboards/client-dashboard";
import ClientTable from "../pages/clients/Client-table";
import ClientAdd from "../pages/clients/Client-Add";
import FormsTable from "../pages/forms/forms-Table";
import FormsAllocationTable from "../pages/forms-allocation/forms-allocation-Table";
import FormsBuilder from "../pages/forms/forms-Builder";
import PoliciesProceduresTable from "../pages/policies-procedures/policies-procedures-View";
import FormsView from "../pages/forms/forms-View";
import IndustryView from "../pages/industries/Industry-View";
import IndustryAdd from "../pages/industries/Industry-Add";
import DepartmentOfLabourView from "../pages/department-of-labour/department-of-labour-view";
import EmergencyContactsView from "../pages/emergency-contacts/emergency-contacts-view";
import LegislationView from "../pages/legislation/legislation-view";
import DsfAdminView from "../pages/dsf-admin/dsf-admin-View";
import ClientAdminTable from "../pages/client-admin/Client-Admin-table";
import ConsultantsTable from "../pages/consultants/consultants-Table";
import ConsultantsView from "../pages/consultants/consultants-View";
import EmployeeTable from "../pages/employee/Employee-table";
import EmployeeView from "../pages/employee/Employee-view";
import EquipmentTable from "../pages/equipment/Equipment-table";
import VehicleTable from "../pages/vehicle/vehicle-table";
import ChemicalTable from "../pages/chemical/chemical-table";
import EquipmentView from "../pages/equipment/Equipment-view";
import VehicleView from "../pages/vehicle/vehicle-view";
import ChemicalView from "../pages/chemical/chemical-view";
import AccessLevelsTable from "../pages/access-levels/access-levels-Table";
import ClientAccessLevelsTable from "../pages/access-levels/client-access-levels-Table";
import AccessLevelsView from "../pages/access-levels/access-levels-View";
import RolesView from "../pages/roles/roles-View";
import AppointmentsView from "../pages/appointments/appointments-View";
import AppointmentsTree from "../pages/appointments/appointments-Tree";
import EquipmentTypesView from "../pages/equipment-types/equipment-types-View";
import VehicleTypesTable from "../pages/vehicle-types/vehicle-types-Table";
import ChemicalTypesTable from "../pages/chemical-types/chemical-types-Table";
import DocumentsView from "../pages/documents/documents-View";
import DocumentsHistoryView from "../pages/documents/documents-history-View";
import SiteTable from "../pages/site/Site-table";
import SiteEmployeeTable from "../pages/site/site-employee/Site-Employee-table";
import EquipmentListView from "../pages/equipment-list/equipment-list-View";
import RiskHazardView from "../pages/risk-hazard/risk-hazard-View";
import RiskAssessmentView from "../pages/risk-assessment/risk-assessment-View";
import SafeWorkMethodView from "../pages/safe-work-method/safe-work-method-View";
import RiskJobTaskTable from "../pages/risk-job-task/risk-job-task-Table";
import RiskJobStepTable from "../pages/risk-job-step/risk-job-step-Table";
import TaskView from "../pages/task/task-View";
import SubContractorTable from "../pages/subcontractor/SubContractor-table";
import SubContractorView from "../pages/subcontractor/SubContractor-view";
import AttendanceView from "../pages/attendance/attendance-view";
import BillingView from "../pages/billing/billing-View";
import BillingAdminView from "../pages/billing/billing-AdminView";
import CommunicationHistory from "../pages/communication/communication-history";
import InductionTable from "../pages/Induction/Induction-table";
import IncidentTypesView from "../pages/incident-types/incident-types-View";
import IncidentView from "../pages/site/site-incidents/incident-view";
import SiteDSFTable from "../pages/site/site-dsf/Site-dsf-table";
import EmergencyContact from "../pages/site/site-dsf/dsf-emergency-contact/EmergencyContact";
import SiteEquipmentTable from "../pages/site/site-equipment/Site-Equipment-table";
import SiteVehicleTable from "../pages/site/site-vehicle/Site-Vehicle-table";
import SiteChemicalTable from "../pages/site/site-chemical/Site-Chemical-table";
import CompanyDocuments from "../pages/site/site-dsf/dsf-company-documents/CompanyDocuments";
import PoliciesProcedures from "../pages/site/site-dsf/dsf-policies-procedures/PoliciesProcedures";
import Organogram from "../pages/site/site-dsf/dsf-organogram/Organogram";
import EmployeeDatabase from "../pages/site/site-dsf/dsf-employee-database/EmployeeDatabase";
import SiteDocuments from "../pages/site/site-dsf/dsf-site-documents/SiteDocuments";
import SiteAttendance from "../pages/site/site-dsf/dsf-site-attendance/SiteAttendance";
import EquipmentListAndChecklists from "../pages/site/site-dsf/lists-and-checklists/dsf-equipment-list/EquipmentListAndChecklists";
import VehicleListAndChecklist from "../pages/site/site-dsf/lists-and-checklists/dsf-vehicle-list/VehicleListAndChecklist";
import ChemicalListAndChecklist from "../pages/site/site-dsf/lists-and-checklists/def-chemical-list/ChemicalListAndChecklist";
import IncidentTypes from "../pages/site/site-dsf/dsf-incident-types/IncidentTypes";
import OSHActAndLegislations from "../pages/site/site-dsf/dsf-osh-act-legislation/OSHActAndLegislations";
import ToolboxTalks from "../pages/site/site-dsf/dsf-toolbox-talks/ToolboxTalks";
import SiteInduction from "../pages/site/site-dsf/dsf-site-induction/SiteInduction";
import SiteInductionView from "../pages/site/site-induction/Site-Induction-View";
import ToolboxTalksPagesTable from "../pages/toolbox-talks-pages/toolbox-talks-pages-table";
import ToolboxTalksTable from "../pages/toolbox-talks/toolbox-talks-view";
import ToolboxTalksDetails from "../pages/toolbox-talks/toolbox-talks-details";
import PtoTopicsView from "../pages/pto/admin/pto-topics/pto-topics-View";
import PPEView from "../pages/ppe/ppe-View";
import ControlMeasureTypeTable from "../pages/control-measure-types/control-measure-types-Table";
import ControlMeasureTable from "../pages/control-measure/control-measure-Table";
import SiteDSTI from "../pages/site/site-dsti/SiteDSTI";
import DSTIDetails from "../pages/site/site-dsti/view/DSTIDetails";
import JobTaskCategoryView from "../pages/job-task-category/job-task-category-View";
import TaskTable from "../pages/task/task-Table";
import PtoList from "../pages/site/site-pto/pto-list";
import ChecklistTemplateTableView from "../pages/checklist/ChecklistTemplateTableView";
import ChecklistTaskTracker from "../pages/checklist/ChecklistTaskTracker";
import ChecklistDashboard from "../pages/checklist/ChecklistDashboard";
import DailyTaskPlan from "../pages/site/daily-task-plan/DailyTaskPlan";
import DailyTaskPlanDetail from "../pages/site/daily-task-plan/detail/DailyTaskPlanDetail";
import ChecklistSubmissionsPage from "../pages/site/Checklists/ChecklistSubmissions";
import ChecklistSubmissionDetails from "../pages/site/Checklists/Submissions/SubmissionDetails";
import NonComplianceTracker from "../pages/non-compliance/NonComplianceTracker";
import SiteSetup from "../pages/site/SiteSetup/SiteSetup";
import SummaryScopeOfWork from "../pages/site/scope-of-work/summary/SummaryScopeOfWork";
import JobTasks from "../pages/site/scope-of-work/job-task/JobTask";
import Appointments from "../pages/site/people-and-attendance/appointments/Appointments";
import SiteDashboard from "../pages/site/dashboard/Dashboard";
import SiteDetails from "../pages/site/site-details/details";
import SiteClient from "../pages/site/site-details/client";
import SiteProfessionalTeam from "../pages/site/site-details/professional-team";
import SiteDsfPoster from "../pages/site/site-details/site-dsf-poster";
import SiteSchedule from "../pages/site/site-details/schedule";
import SiteDetailDocuments from "../pages/site/site-details/site-documents";
import GeneralDetails from "../pages/client/profile/general-details";
import RegistrationDetails from "../pages/client/profile/registration-details";
import ContactDetails from "../pages/client/profile/contact-details";
import ClientDocuments from "../pages/client/profile/company-documents";
import SiteOrganogram from "../pages/site/site-organogram/site-organogram";
import SiteRiskAssessment from "../pages/site/risk-assessment/site-risk-assessment";
import SiteSubcontractorTable from "../pages/site/site-subcontractors/Site-Subcontractors-table";

const routesArray = [
  {
    path: "/",
    element: AdminDashboard,
    access: ["DSF"],
  },
  {
    path: "/",
    element: ConsultantDashboard,
    access: ["Consultant"],
  },
  {
    path: "/",
    element: ClientDashboard,
    access: ["Client", "Admin"],
  },
  {
    path: "/admin-dashboard",
    element: AdminDashboard,
    access: ["DSF"],
  },
  {
    path: "/client-dashboard",
    element: ClientDashboard,
    access: ["DSF", "Client"],
  },
  {
    path: "/client-table",
    element: ClientTable,
    access: ["DSF", "Consultant"],
  },
  {
    path: "/client-add",
    element: ClientAdd,
    access: ["DSF", "Consultant"],
  },
  /*
  CLIENT MENU SECTION
   */
  {
    path: "/profile/general-details",
    element: GeneralDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/profile/registration-details",
    element: RegistrationDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/profile/contact-details",
    element: ContactDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/profile/company-documents",
    element: ClientDocuments,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/form-table",
    element: FormsTable,
    access: ["DSF"],
  },
  {
    path: "/form-allocation-table",
    element: FormsAllocationTable,
    access: ["DSF"],
  },
  // {
  //   path: '/form-allocation-add',
  //   element: FormAllocationAdd as () => JSX.Element,
  //   access: ['DSF']
  // },
  {
    path: "/form-builder",
    element: FormsBuilder,
    access: ["DSF"],
  },
  {
    path: "/template-table",
    element: PoliciesProceduresTable,
    access: ["DSF", "Client"],
  },
  {
    path: "/checklist-template-table",
    element: ChecklistTemplateTableView,
    access: ["DSF", "Client"],
  },
  {
    path: "/client/:clientId/checklist-template-table",
    element: ChecklistTemplateTableView,
    access: ["DSF", "Admin"],
  },
  {
    path: "/checklist-task-tracker",
    element: ChecklistTaskTracker,
    access: ["DSF", "Client"],
  },
  {
    path: "/checklist-dashboard",
    element: ChecklistDashboard,
    access: ["DSF"],
  },
  {
    path: "/checklists-overview",
    element: ChecklistTemplateTableView,
    access: ["DSF"],
  },
  {
    path: "/form-view",
    element: FormsView,
    access: ["DSF"],
  },
  {
    path: "/industries",
    element: IndustryView,
    access: ["DSF"],
  },
  {
    path: "/industries-add",
    element: IndustryAdd,
    access: ["DSF"],
  },
  {
    path: "/department-of-labour",
    element: DepartmentOfLabourView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/emergency-contact",
    element: EmergencyContactsView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/legislation",
    element: LegislationView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/dsf-admin",
    element: DsfAdminView,
    access: ["DSF"],
  },
  {
    path: "/client-admin",
    element: ClientAdminTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/consultant-dashboard",
    element: ConsultantDashboard,
    access: ["DSF"],
  },
  {
    path: "/consultant-table",
    element: ConsultantsTable,
    access: ["DSF"],
  },
  {
    path: "/consultant-view/:id",
    element: ConsultantsView,
    access: ["DSF", "Consultant"],
  },
  {
    path: "/employee-table",
    element: EmployeeTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/employee-view",
    element: EmployeeView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/equipment-table",
    element: EquipmentTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/vehicle-table",
    element: VehicleTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/chemical-table",
    element: ChemicalTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/equipment-view",
    element: EquipmentView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/vehicle-view",
    element: VehicleView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/chemical-view",
    element: ChemicalView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/access-level-table",
    element: AccessLevelsTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/client-access-level-table",
    element: ClientAccessLevelsTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/access-level-view",
    element: AccessLevelsView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/role-table",
    element: RolesView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/appointment-table",
    element: AppointmentsView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/appointment-tree",
    element: AppointmentsTree,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/equipment-types-table",
    element: EquipmentTypesView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/vehicle-types-table",
    element: VehicleTypesTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/chemical-types-table",
    element: ChemicalTypesTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/documents-table",
    element: DocumentsView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/documents-history",
    element: DocumentsHistoryView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-equipment-table",
    element: SiteEquipmentTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-vehicle-table",
    element: SiteVehicleTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-chemical-table",
    element: SiteChemicalTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/equipment-list-table",
    element: EquipmentListView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-table",
    element: SiteTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  // {
  //   path: "/site-view",
  //   element: SiteView,
  //   access: ["DSF", "Consultant", "Client", "Admin"],
  // },
  {
    path: "/site-employee-table",
    element: SiteEmployeeTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/equipment-list-table",
    element: EquipmentListView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/risk-hazard-table",
    element: RiskHazardView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/risk-assessment-table",
    element: RiskAssessmentView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/safe-work-method-table",
    element: SafeWorkMethodView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/risk-task-table",
    element: RiskJobTaskTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/risk-step-table",
    element: RiskJobStepTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/task-view",
    element: TaskView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/task-table",
    element: TaskTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/task-table/:title/:subTitle/:type",
    element: TaskTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/subcontractor-table",
    element: SubContractorTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/sub-contractor-view",
    element: SubContractorView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/attendance-table",
    element: AttendanceView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/billing-view",
    element: BillingView,
    access: ["DSF"],
  },
  {
    path: "/billing-view-client",
    element: BillingAdminView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/communication-view",
    element: CommunicationHistory,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/induction-table",
    element: InductionTable,
    access: ["DSF"],
  },
  {
    path: "/incident-type-view",
    element: IncidentTypesView,
    access: ["DSF"],
  },
  {
    path: "/site-incidents",
    element: IncidentView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/toolbox-talk-pages-table",
    element: ToolboxTalksPagesTable,
    access: ["DSF"],
  },
  {
    path: "/toolbox-talk-table",
    element: ToolboxTalksTable,
    access: ["DSF"],
  },
  {
    path: "/pto-topic-table",
    element: PtoTopicsView,
    access: ["DSF"],
  },
  {
    path: "/ppe-table",
    element: PPEView,
    access: ["DSF", "Client", "Admin"],
  },
  {
    path: "/toolbox-talk-view/:toolbox_id",
    element: ToolboxTalksDetails,
    access: ["DSF"],
  },
  // ToolboxTalksDetails
  {
    path: "/site-organogram",
    element: SiteOrganogram,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table",
    element: SiteDSFTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-emergency-contact",
    element: EmergencyContact,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-company-documents",
    element: CompanyDocuments,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-policies-procedures",
    element: PoliciesProcedures,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-organogram-legal-appointments",
    element: Organogram,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-employee-database",
    element: EmployeeDatabase,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-site-project-documents",
    element: SiteDocuments,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-site-attendance",
    element: SiteAttendance,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-equipment-list-checklists",
    element: EquipmentListAndChecklists,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-vehicle-list-checklists",
    element: VehicleListAndChecklist,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-chemical-list-sds",
    element: ChemicalListAndChecklist,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-incidents",
    element: IncidentTypes,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-ohs-act-legislations",
    element: OSHActAndLegislations,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-toolbox-talks",
    element: ToolboxTalks,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-dsf-table/dsf-induction",
    element: SiteInduction,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-induction",
    element: SiteInductionView,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/control-measure-type-table",
    element: ControlMeasureTypeTable,
    access: ["DSF"],
  },
  {
    path: "/control-measure-table",
    element: ControlMeasureTable,
    access: ["DSF"],
  },
  {
    path: "/site-dsti",
    element: SiteDSTI,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-pto",
    element: PtoList,
    access: ["DSF", "Client", "Admin"],
  },
  {
    path: "/site-dsti/:id",
    element: DSTIDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/job-task-category",
    element: JobTaskCategoryView,
    access: ["DSF"],
  },
  {
    path: "/daily-task-plan",
    element: DailyTaskPlan,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/daily-task-plan/:id",
    element: DailyTaskPlanDetail,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/daily-task-plan/:id/start",
    element: DailyTaskPlanDetail,
    access: ["DSF", "Client", "Admin"],
  },
  {
    path: "/site-checklist-submissions",
    element: ChecklistSubmissionsPage,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-checklist-submissions/:id",
    element: ChecklistSubmissionDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/non-compliance",
    element: NonComplianceTracker,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-setup",
    element: SiteSetup,
    access: ["DSF", "Client", "Admin"],
  },
  {
    path: "/scope-of-work/summary",
    element: SummaryScopeOfWork,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/scope-of-work/job-tasks",
    element: JobTasks,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/people-and-attendance/appointments",
    element: Appointments,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/dashboard",
    element: SiteDashboard,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/details",
    element: SiteDetails,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/client",
    element: SiteClient,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/professional-team",
    element: SiteProfessionalTeam,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/site-dsf-poster",
    element: SiteDsfPoster,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/schedule",
    element: SiteSchedule,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/site-details/site-documents",
    element: SiteDetailDocuments,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/hira/risk-assessments",
    element: SiteRiskAssessment,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
  {
    path: "/people-and-attendance/sub-contractors",
    element: SiteSubcontractorTable,
    access: ["DSF", "Consultant", "Client", "Admin"],
  },
];

export { routesArray };
